export default __webpack_public_path__ + "74ae3d843abf1b911947e089bafc1571.png";